export const REGISTER_USER = "REGISTER_USER";
export const REGISTER_USER_SUCCESSFUL = "REGISTER_USER_SUCCESSFUL";
export const REGISTER_USER_FAILED = "REGISTER_USER_FAILED";
export const RESET_REGISTER_FLAG = "RESET_REGISTER_FLAG";

// Verify Email
export const VERIFY_EMAIL = "VERIFY_EMAIL";
export const VERIFY_EMAIL_SUCCESSFUL = "VERIFY_EMAIL_SUCCESSFUL";
export const VERIFY_EMAIL_FAILED = "VERIFY_EMAIL_FAILED";

// request new verification token by sending email

export const VERIFY_EMAIL_REQUEST_NEW_TOKEN = "VERIFY_EMAIL_REQUEST_NEW_TOKEN";
export const VERIFY_EMAIL_REQUEST_NEW_TOKEN_SUCCESSFUL =
  "VERIFY_EMAIL_REQUEST_NEW_TOKEN_SUCCESSFUL";
export const VERIFY_EMAIL_REQUEST_NEW_TOKEN_FAILED =
  "VERIFY_EMAIL_REQUEST_NEW_TOKEN_FAILED";

// Create Company
export const CREATE_COMPANY = "CREATE_COMPANY";
export const CREATE_COMPANY_SUCCESSFUL = "CREATE_COMPANY_SUCCESSFUL";
export const CREATE_COMPANY_FAILED = "CREATE_COMPANY_FAILED";

// verify user invitation to join a company
export const VERIFY_USER_INVITATION = "VERIFY_USER_INVITATION";
export const VERIFY_USER_INVITATION_SUCCESSFUL =
  "VERIFY_USER_INVITATION_SUCCESSFUL";
export const VERIFY_USER_INVITATION_FAILED = "VERIFY_USER_INVITATION_FAILED";

// Accept Invite and create new user account
export const ACCEPT_INVITE_CREATE_NEW_USER_ACCOUNT =
  "ACCEPT_INVITE_CREATE_NEW_USER_ACCOUNT";
export const ACCEPT_INVITE_CREATE_NEW_USER_ACCOUNT_SUCCESSFUL =
  "ACCEPT_INVITE_CREATE_NEW_USER_ACCOUNT_SUCCESSFUL";
export const ACCEPT_INVITE_CREATE_NEW_USER_ACCOUNT_FAILED =
  "ACCEPT_INVITE_CREATE_NEW_USER_ACCOUNT_FAILED";

export const AUTHENTICATION_REQUEST_FOR_EMAIL_PASSWORD_RESET =
  "AUTHENTICATION_REQUEST_FOR_EMAIL_PASSWORD_RESET";
export const AUTHENTICATION_REQUEST_FOR_EMAIL_PASSWORD_RESET_SUCCESSFUL =
  "AUTHENTICATION_REQUEST_FOR_EMAIL_PASSWORD_RESET_SUCCESSFUL";
export const AUTHENTICATION_REQUEST_FOR_EMAIL_PASSWORD_RESET_FAILED =
  "AUTHENTICATION_REQUEST_FOR_EMAIL_PASSWORD_RESET_FAILED";

export const RESET_PASSWORD = "RESET_PASSWORD";
export const RESET_PASSWORD_SUCCESSFUL = "RESET_PASSWORD_SUCCESSFUL";
export const RESET_PASSWORD_FAILED = "RESET_PASSWORD_FAILED";
